module.exports = __webpack_public_path__ + "static/media/SPACE32_profielfoto_Bart.e7909a6c.png";